<template>
    <div>
        <text-form-group
                v-model="data.line_one"
                name="line_one"
                label="Line One"
                :error="(errors.line_one || [])[0]"
        />

        <text-form-group
                v-model="data.line_two"
                name="line_two"
                label="Line Two"
                :error="(errors.line_two || [])[0]"
        />

        <text-form-group
                v-model="data.line_three"
                name="line_three"
                label="Line Three"
                :error="(errors.line_three || [])[0]"
        />
    </div>
</template>

<script>
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        computed: {
            data: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    }
</script>
